import {
    ICertificate,
    localScopeOptions,
    certificateNotesOptions,
    passengersOptions,
} from "../../../models/certificate";
import { getLatinNonLatinCombined, IIDDataSet } from "../../../models/crewMember";
import { CrewMemberImage } from "../../CrewMember/CrewMemberImage";
import coatOfArmsAt from "../../../images/coat_of_arms_at.png";
import { formatDate } from "../../../models/common";

type Props = {
    certificate: ICertificate;
    idDataSet: IIDDataSet;
    modifyable: boolean;
};

export const BoatMasterATCertificateView = ({ certificate, idDataSet, modifyable }: Props) => {
    return (
        <>
            <p id="tag">Front</p>
            <div className="certificate-front">
                <div className="front-left">
                    <p className="front-headline">SCHIFFSFÜHRERZEUGNIS AT</p>
                    <p id="positions" style={{ paddingTop: "10px" }}>
                        1.&nbsp;
                        {getLatinNonLatinCombined(idDataSet.nonLatinLastName, idDataSet.lastName)}
                    </p>
                    <p id="positions">
                        2.&nbsp;
                        {getLatinNonLatinCombined(idDataSet.nonLatinFirstName, idDataSet.firstName)}
                    </p>
                    <p id="positions">
                        3.&nbsp;
                        {formatDate(idDataSet.dateOfBirth) +
                            " - " +
                            getLatinNonLatinCombined(
                                idDataSet.nonLatinPlaceOfBirth,
                                idDataSet.placeOfBirth
                            )}
                    </p>
                    <p id="positions" style={{ paddingBottom: "20px" }}>
                        4.&nbsp;{formatDate(certificate.startDate)}
                    </p>
                    <p id="positions">
                        8.&nbsp;
                        {
                            localScopeOptions.find(x => x.value === certificate.localScope)
                                ?.content as string
                        }
                        &nbsp;{certificate.localScopeValue}
                    </p>
                    <p id="positions">9.&nbsp;{writeScope(certificate)}</p>
                    <p id="positions">10.&nbsp;{formatDate(certificate.endDate)}</p>
                    <p style={{ paddingBottom: "70px" }}>
                        11.&nbsp;{writeAtCertificateNotes(certificate)}
                    </p>
                </div>
                <div className="front-right">
                    <p className="front-headline">REPUBLIK ÖSTERREICH</p>
                    <img src={coatOfArmsAt} alt="coatOfArmsAT" id="coatOfArms"></img>
                    <div className="picture">
                        <p style={{ paddingTop: "105px", paddingRight: "4px" }}>6.</p>
                        <div className="picture-frame">
                            <CrewMemberImage imageBase64={idDataSet.imageBase64} />
                        </div>
                    </div>
                    <p style={{ paddingTop: "20px" }}>
                        5.&nbsp;{modifyable ? <em>Wird zugeteilt</em> : certificate.qualificationID}
                    </p>
                </div>
            </div>
            <p id="tag" style={{ paddingTop: "30px" }}>
                Back
            </p>
            <div className="certificate-back">
                <p style={{ textAlign: "center" }}>SCHIFFSFÜHRERZEUGNIS AT</p>
                <p id="positions">
                    1.&nbsp;&nbsp;&nbsp;Name der Inhaberin/des Inhabers, akademischer Grad
                </p>
                <p id="positions">2.&nbsp;&nbsp;&nbsp;Vorname(n)</p>
                <p id="positions">3.&nbsp;&nbsp;&nbsp;Geburtsdatum und -ort</p>
                <p id="positions">4.&nbsp;&nbsp;&nbsp;Ausstellungsdatum des Patents/Zeugnisses</p>
                <p id="positions">5.&nbsp;&nbsp;&nbsp;Ausstellungsnummer</p>
                <p id="positions">6.&nbsp;&nbsp;&nbsp;Lichtbild der Inhaberin/des Inhabers</p>
                <p id="positions">7.&nbsp;&nbsp;&nbsp;Unterschrift der Inhaberin/des Inhabers</p>
                <p id="positions">8.&nbsp;&nbsp;&nbsp;Örtlicher Geltungsbereich</p>
                <p id="positions">
                    9.&nbsp;&nbsp;&nbsp;Sachlicher Geltungsbereich (Fahrzeugart, Radar, Fahrgäste,
                    Fahrzeuglänge)
                </p>
                <p id="positions">10.&nbsp;&nbsp;&nbsp;Verfalldatum</p>
                <p style={{ paddingBottom: "70px" }}>
                    11.&nbsp;&nbsp;&nbsp;Vermerke, Einschränkungen
                </p>
            </div>
        </>
    );
};

const writeScope = (certificate: ICertificate) => {
    const result: string[] = [];

    if (certificate.vehicleType) {
        result.push(`Fahrzeugtyp: ${certificate.vehicleType}`);
    }

    result.push(passengersOptions.find(x => x.value === certificate.passengers)?.content as string);

    if (certificate.radar) {
        result.push("Radar");
    } else {
        result.push("Kein Radar");
    }
    if (certificate.vehicleLengthBoatmaster) {
        result.push("< 20m");
    }
    if (!!certificate.materialScope) {
        result.push(certificate.materialScope);
    }
    return result.join(", ");
};

const writeAtCertificateNotes = (certificate: ICertificate) => {
    const notes: string[] = [];
    certificate.certificateNotes.forEach(cn => {
        const value = certificateNotesOptions.find(x => x.value === cn)?.content as string;
        if (!!value) {
            notes.push(value);
        }
    });
    if (notes.length > 0) {
        if (!!certificate.notesValue) {
            notes.push(certificate.notesValue);
        }
        return notes.join(", ");
    } else {
        return "--";
    }
};
